import styled from 'styled-components';

export const StyledElement = styled.li`
  @media (max-width: 470px) {
    ${(props) => {
      if (!props.isLogout) {
        return `
          display: none;
        `;
      }
      return '';
    }}
  }

  .disabled-item {
    color: #858585;
    display: flex;
    width: 100%;
    text-align: left;
    padding: ${(props) => (props.isCollapsed ? '12px 8px' : '12px 16px')};
    border-radius: 12px;
    align-items: center;
    justify-content: ${(props) =>
      props.isCollapsed ? 'center' : 'flex-start'};
    font-weight: 400;
    font-size: 14px;
    opacity: 0.8;
    cursor: default;

    svg {
      margin-right: ${(props) => (props.isCollapsed ? '0' : '12px')};
      font-size: 20px;
      opacity: 0.8;
    }

    span {
      opacity: 0.8;
    }
  }

  button {
    color: rgba(244, 241, 222, 0.8);
    background: transparent;
    border: 0;
    display: flex;
    width: 100%;
    text-align: left;
    padding: ${(props) => (props.isCollapsed ? '12px 8px' : '12px 16px')};
    border-radius: 12px;
    align-items: center;
    justify-content: ${(props) =>
      props.isCollapsed ? 'center' : 'flex-start'};
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;
    font-weight: 500;
    font-size: 14px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(244, 241, 222, 0.05);
      border-radius: 12px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    svg {
      margin-right: ${(props) => (props.isCollapsed ? '0' : '12px')};
      font-size: 20px;
      transition: all 0.3s ease;
      position: relative;
      z-index: 2;
    }

    span {
      transition: all 0.3s ease;
      position: relative;
      z-index: 2;
    }

    ${(props) => {
      if (props.isHovered) {
        return `
          color: #f4f1de;
          font-weight: 600;
          
          &::before {
            opacity: 1;
            background: rgba(244, 241, 222, 0.1);
          }
          
          svg {
            transform: scale(1.1);
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
          }
        `;
      }
    }}

    ${(props) =>
      props.isActive &&
      `
      :hover {
        color: #f4f1de;
        font-weight: 600;
        
        &::before {
          opacity: 1;
          background: rgba(244, 241, 222, 0.1);
        }
        
        svg {
          transform: scale(1.1);
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
        }
      }
    `}

    ${(props) => {
      if (props.isLogout) {
        return `
          border-top: 1px solid rgba(244, 241, 222, 0.2);
          color: rgba(220, 53, 69, 0.8);
          margin-top: 20px;
          padding-top: 16px;

          :hover {
            color: #dc3545;
            font-weight: 600;
            
            &::before {
              opacity: 1;
              background: rgba(220, 53, 69, 0.1);
            }
            
            svg {
              transform: scale(1.1);
              filter: drop-shadow(0 2px 4px rgba(220, 53, 69, 0.3));
            }
          }         
        `;
      }
    }}
  }
`;